// extracted by mini-css-extract-plugin
module.exports = {"root":"HeroImageBlock-module--root---faLh","image":"HeroImageBlock-module--image--K3nTx","overlay":"HeroImageBlock-module--overlay--WaNu3"};